export const DEFAULT_APP_VERSION = "v1";

/**
 * custom:variant marker meaning "this account picks its system at login"
 * rather than being pinned to one. A value of exactly "vx" offers every
 * VARIANT_OPTIONS entry; "vx:<key>[,<key>...]" restricts the picker to
 * those keys (see allowedVariantKeys in config/useRouterVersionConfig).
 */
export const VARIANT_VX = "vx";

/**
 * The systems a "vx" account can be sent to. `key` is the URL version
 * prefix the app routes under after selection ("/v2/...", "/v3/..."), and
 * `icon` names an entry in VariantSelector's ICON_MAP.
 *
 * The selector renders these in a grid, so adding a third entry here needs
 * no layout change.
 */
export const VARIANT_OPTIONS = [
  {
    key: "v2",
    label: "LA Metro Gateway",
    icon: "trainSubway",
  },
  {
    key: "v3",
    label: "LA Metro Railway",
    icon: "train",
  },
];
